export default {
  en: {
    'bundles.jurisdictions.jurisdictions-list-page.title': 'Jurisdictions',
    'bundles.jurisdictions.jurisdictions-list-page.add-registration': 'Add Registration',
    'bundles.jurisdictions.jurisdictions-list-page.no-results.title': 'No Registrations',
    'bundles.jurisdictions.jurisdictions-list-page.no-results.description':
      "Looks like you don't have any registrations yet.",
  },
};
